const YOUTUBE_VIDEO_ID_REGEX = /^[A-Za-z0-9_-]{11}$/

const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
])

export function extractYoutubeVideoId(value?: string): string | undefined {
  const input = value?.trim()
  if (!input) return undefined
  if (YOUTUBE_VIDEO_ID_REGEX.test(input)) return input

  try {
    const url = new URL(/^https?:\/\//i.test(input) ? input : `https://${input}`)
    const host = url.hostname.toLowerCase()
    const pathParts = url.pathname.split('/').filter(Boolean)
    let videoId: string | null | undefined

    if (host === 'youtu.be' || host === 'www.youtu.be') videoId = pathParts[0]
    else if (YOUTUBE_HOSTS.has(host)) {
      if (url.pathname === '/watch') videoId = url.searchParams.get('v')
      else if (['embed', 'shorts', 'live'].includes(pathParts[0])) videoId = pathParts[1]
    }

    return videoId && YOUTUBE_VIDEO_ID_REGEX.test(videoId) ? videoId : undefined
  } catch {
    return undefined
  }
}

export function formatYoutubeVideoInput(value: string): string {
  return YOUTUBE_VIDEO_ID_REGEX.test(value.trim())
    ? `https://www.youtube.com/watch?v=${value.trim()}`
    : value
}
